import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-tile-slider' })
export class TileSliderComponent {
	private swiper: Swiper;

	constructor(private element: HTMLElement) {
		this.swiper = new Swiper(element, {
			slidesPerView: 'auto',
			spaceBetween: 0,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			}
		});
	}
}
